module.exports = __webpack_public_path__ + "6505f74cc2805905a5c8adfe07a02e6b.pdf";